import {
  useLayoutEffect,
  useRef,
  type MutableRefObject,
} from "react";

export function useLatestSessionValueRef<T>(
  value: T,
): MutableRefObject<T> {
  const ref = useRef(value);

  useLayoutEffect(() => {
    ref.current = value;
  }, [value]);

  return ref;
}
